import { newE2EPage } from "@stencil/core/testing";

describe("uic-virtual-scroll", () => {
    it("renders", async () => {
        const page = await newE2EPage();
        await page.setContent("<uic-virtual-scroll></uic-virtual-scroll>");

        const element = await page.find("uic-virtual-scroll");
        expect(element).toHaveClass("hydrated");
    });

    it("derives total number of items from provided list in attribute `items`", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-virtual-scroll></uic-virtual-scroll>`);

        await page.$eval("uic-virtual-scroll", (el: HTMLUicVirtualScrollElement) => {
            el.itemHeight = 36;
            el.items = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
        });

        await page.waitForChanges();

        const itemsContainer = await page.find("uic-virtual-scroll .simplebar-content > div");

        expect((await itemsContainer.innerHTML).trim()).not.toEqual("");
        expect((await itemsContainer.getComputedStyle()).height).toBe("360px");
    });

    it("processes total number of items provided as scalar in attribute `items`", async () => {
        const logs = [];

        const page = await newE2EPage();
        page.on("console", (msg) => logs.push(msg.text()));
        await page.setContent(`<uic-virtual-scroll></uic-virtual-scroll>`);

        await page.$eval("uic-virtual-scroll", (el: HTMLUicVirtualScrollElement) => {
            el.itemHeight = 36;
            el.items = 10;
        });

        await page.waitForChanges();

        const itemsContainer = await page.find("uic-virtual-scroll .simplebar-content > div");

        expect((await itemsContainer.innerHTML).trim()).toEqual("");
        expect((await itemsContainer.getComputedStyle()).height).toBe("360px");

        expect(logs.length).toEqual(1);
        expect(logs[0]).toMatch(/\bgetItems\b/);
    });

    it("applies default renderer indicating lack of custom renderer per item", async () => {
        const page = await newE2EPage();
        await page.setContent(`<uic-virtual-scroll></uic-virtual-scroll>`);

        await page.$eval("uic-virtual-scroll", (el: HTMLUicVirtualScrollElement) => {
            el.itemHeight = 36;
            el.items = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
        });

        await page.waitForChanges();

        const items = await page.findAll(".missing-renderer");
        expect(items.length).toBeGreaterThan(0);
    });

    it("invokes provided callback for retrieval of items", async () => {
        const logs = [];

        const page = await newE2EPage();
        page.on("console", (msg) => logs.push(msg.text()));
        await page.setContent(`<uic-virtual-scroll></uic-virtual-scroll>`);

        await page.$eval("uic-virtual-scroll", (el: HTMLUicVirtualScrollElement) => {
            el.itemHeight = 36;
            el.items = 100;
            el.getItems = (start, end) => {
                // eslint-disable-next-line
                console.log(`fetching ${end - start} @ ${start}..${end}`);
                return new Array(end - start).fill(0);
            };
        });

        await new Promise((r) => setTimeout(r, 100));

        expect(logs.filter((msg) => /^fetching /.test(msg))).toHaveLength(1);

        const items = await page.findAll(".missing-renderer");
        expect(items.length).toBeGreaterThan(0);
    });

    it("accepts promise resolved with items on invoking provided callback for retrieval of items", async () => {
        const logs = [];

        const page = await newE2EPage();
        page.on("console", (msg) => logs.push(msg.text()));
        await page.setContent(`<uic-virtual-scroll></uic-virtual-scroll>`);

        await page.$eval("uic-virtual-scroll", (el: HTMLUicVirtualScrollElement) => {
            el.itemHeight = 36;
            el.items = 100;
            el.getItems = (start, end) => {
                // eslint-disable-next-line
                console.log(`fetching ${end - start} @ ${start}..${end}`);
                return new Promise((resolve) => {
                    setTimeout(resolve, 10, new Array(end - start).fill(0));
                });
            };
        });

        await new Promise((r) => setTimeout(r, 500));

        expect(logs.filter((msg) => /^fetching /.test(msg))).toHaveLength(1);

        const items = await page.findAll(".missing-renderer");
        expect(items.length).toBeGreaterThan(0);
    });

    it("does not invoke provided callback for retrieval of items on providing list of items", async () => {
        const logs = [];

        const page = await newE2EPage();
        page.on("console", (msg) => logs.push(msg.text()));
        await page.setContent(`<uic-virtual-scroll></uic-virtual-scroll>`);

        await page.$eval("uic-virtual-scroll", (el: HTMLUicVirtualScrollElement) => {
            el.itemHeight = 36;
            el.items = [];
            el.getItems = (start, end) => {
                // eslint-disable-next-line
                console.log(`fetching ${end - start} @ ${start}..${end}`);
                return new Array(end - start);
            };
        });

        await page.waitForChanges();

        expect(logs.filter((msg) => /^fetching /.test(msg))).toHaveLength(0);
    });
});
